import { Component, OnInit, Inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Tabel } from 'src/app/interfaces/auth.interface';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-tableno',
  templateUrl: './tableno.component.html',
  styleUrls: ['./tableno.component.scss']
})

export class TablenoComponent implements OnInit {

  constructor(private as:AuthService) { }

  ngOnInit(): void {}

  errr:string = ''

  submit:boolean = true

  loading:boolean = false

  signup(f:NgForm){
    let data:Tabel = f.value
      this.submit = false
      this.loading = true
      let dateObject = new Date();
      let stringDate = dateObject.toString()
      this.as.checkMail(data.email)
      this.as.passUserData(data.email, data.password , stringDate, data.tableno)
  }

}
